/* global $ */
'use strict';

function Routing(EVENTS, MODALS) {
	window.NIKE = window.NIKE || {};
	window.NIKE.currentPageId = 'notfound';
	window.NIKE.executed = false;
	window.NIKE.campaignsParam = window.NIKE.campaignsParam || {};

	var page = require('page');
	var PubSub = require('pubsub-js');
	var i18n = require('./components/i18n.js');
	var loader = require('./components/loader.js');

	var previousPageId;
	var previousId;

	PubSub.subscribe(EVENTS.PAGE_ENTER, function (msg, data) {
		if (data) {
			window.NIKE.currentPageId = data;
		}
		if (previousPageId) {
			$('#' + previousPageId).removeClass('slideIn right left').addClass('slideOut left');
		}
		$('#' + window.NIKE.currentPageId).removeClass('slideOut right left').addClass('slideIn right');
		previousPageId = window.NIKE.currentPageId;
	});

	function init() {
		if (window.location.pathname !== '/') {
			page.base(window.location.pathname);
		} else {
			page.base('/#!');
		}
		page('/', root);
		page('/notfound', notfound);
		page('/campaign/:campaign', index);
		page('/campaign/:campaign/:country?/:lang?', index);
		page('/campaign/:campaign/:country/:lang/start', start);
		page('/campaign/:campaign/:country/:lang/slick/:id?', slick);
		page('/campaign/:campaign/:country/:lang/login', login);
		page('/campaign/:campaign/:country/:lang/share', share);
		page('/campaign/:campaign/:country/:lang/termsOfUse', termsOfUse);
		page('/campaign/:campaign/:country/:lang/privacyPolicy', privacyPolicy);
		page('*', notfound);
		page({
			hashbang: true
		});
	}

	function getNavigatorLang(string) {
		if (string) {
			var locale = string.toLowerCase();
			var localeArray = locale.split('-');
			window.NIKE.navigatorLang = localeArray[0];
			if (localeArray[1]) {
				window.NIKE.navigatorCountry = localeArray[1];
			} else {
				window.NIKE.navigatorCountry = window.NIKE.campaignsParam.defaultCountryLang[localeArray[0]];
			}
		} else {
			window.NIKE.navigatorLang = 'en';
			window.NIKE.navigatorCountry = 'gb';
		}
	}

	function manageGlobals(ctx) {
		getNavigatorLang(navigator.language);
		window.NIKE.campaign = ctx.params.campaign ? ctx.params.campaign : false;
		window.NIKE.country = ctx.params.country ? ctx.params.country : window.NIKE.navigatorCountry;
		window.NIKE.lang = ctx.params.lang ? ctx.params.lang : window.NIKE.navigatorLang;
		window.NIKE.locale = window.NIKE.lang + '-' + window.NIKE.country;
		if (window.NIKE.campaign && window.NIKE.campaignsParam.allowedCampaigns[window.NIKE.campaign]) {
			window.NIKE.urlId = '#!/campaign/' + window.NIKE.campaign + '/' + window.NIKE.country + '/' + window.NIKE.lang;
			window.NIKE.currentId = window.NIKE.campaign + window.NIKE.country + window.NIKE.lang;
			window.NIKE.isLoggedIn = window.NIKE.isLoggedIn || false;
			if (!ctx.params.country || !ctx.params.lang) {
				page.redirect(window.NIKE.urlId);
				return false;
			}
			return true;
		} else {
			return false;
		}
	}

	function handlePage(ctx) {
		if (manageGlobals(ctx)) {
			//executed once on load
			if (!window.NIKE.executed) {
				if (previousId === 'notfound') {
					location.reload();
				}
				deleteCookie('CONSUMERCHOICE');
				i18n(EVENTS, MODALS);
				previousId = window.NIKE.currentId;
				window.NIKE.executed = true;
				if (window.location.hash !== window.NIKE.urlId && window.location.hash !== window.NIKE.urlId + '/' && window.location.hash !== window.NIKE.urlId + '/start') {
					page(window.NIKE.urlId + '/start');
				}
			} else {
				PubSub.publish(EVENTS.PAGE_ENTER);
			}
			if (previousId !== window.NIKE.currentId) {
				deleteCookie('CONSUMERCHOICE');
				location.reload();
			}
		} else {
			loader(EVENTS);
			if (ctx.path !== '/notfound') {
				page('/notfound');
				previousId = 'notfound';
			}
			PubSub.publish(EVENTS.PAGE_ENTER);
			PubSub.publish(EVENTS.FIRST_LOAD_DONE);
		}
		PubSub.publish(EVENTS.LAZYLOAD_IMAGES, window.NIKE.currentPageId);
	}

	function deleteCookie(item) {
		document.cookie = item + '=;path=/;domain=' + getCookieDomain() + ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
	}

	function getCookieDomain() {
		var c = location.hostname,
			b = '.nike.com';
		if (c.indexOf(b) >= 0) {
			return b;
		} else {
			return '';
		}
	}

	function defaultPageRedirect() {
		getNavigatorLang(navigator.language);
		page.redirect('/campaign/default/' + window.NIKE.navigatorCountry + '/' + window.NIKE.navigatorLang);
	}

	function root(ctx, next) {
		defaultPageRedirect();
	}

	function index(ctx, next) {
		window.NIKE.currentPageId = 'index';
		handlePage(ctx);
		$('.button-start').attr('href', window.NIKE.urlId + '/start');
	}

	function start(ctx, next) {
		window.NIKE.currentPageId = 'treatment';
		handlePage(ctx);
	}

	function slick(ctx, next) {
		window.NIKE.currentPageId = 'opened';
		handlePage(ctx);
		var treatmentElement = ctx.params.id ? ctx.params.id : 0;
		PubSub.publish(EVENTS.SLICK_GOTO, treatmentElement);
	}

	function login(ctx, next) {
		window.NIKE.currentPageId = 'login';
		handlePage(ctx);
	}

	function share(ctx, next) {
		window.NIKE.currentPageId = 'share';
		handlePage(ctx);
	}

	function termsOfUse(ctx, next) {
		window.NIKE.currentPageId = 'terms-of-use';
		handlePage(ctx);
	}

	function privacyPolicy(ctx, next) {
		window.NIKE.currentPageId = 'privacy-policy';
		handlePage(ctx);
	}

	function notfound(ctx, next) {
		window.NIKE.currentPageId = 'notfound';
		handlePage(ctx);
	}

	$.getJSON('campaigns/campaigns.json', function (data) {
		window.NIKE.campaignsParam = data;
		init();
	}).fail(function () {
		console.log('Can not load campaigns list');
		PubSub.publish(EVENTS.PAGE_ENTER, 'notfound');
		return false;
	});

}

module.exports = Routing;
